export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11372.0c7814a1.jpg";